module.exports = __webpack_public_path__ + "img/PrettyWomanLogo.245dc68b.png";